// extracted by mini-css-extract-plugin
export default {"eventDateContainer":"cVT9Lau8AuiO0pq_OfnH","locationIcon":"LFiJ5BQczudNLrORbDzb"};